export default {
  name: "arrow_desc",
  box: 24,
  svg: `<path
  stroke-linecap="round"
  stroke-linejoin="round"
  stroke-width="2"
  d="M16 17l-4 4m0 0l-4-4m4 4V3"
 stroke="fillcolor"/>`,
};
